'use client';

import { User } from '@auth0/nextjs-auth0/types';
import { datadogRum } from '@moodys-bss/ui-datadog';

export const useSetUser = (user: User | undefined | null) => {
  if (user) {
    datadogRum.setUser({
      email: user.email || undefined,
      id: user.sub || undefined,
      name: user.name || undefined,
    });
  } else {
    datadogRum.clearUser();
  }
};
